export enum NacionalityEnum {
    BRAZILIAN = 'BRAZILIAN',
    FOREIGN = 'FOREIGN'
}
